<template>
  <component :is="layout" />
  <div id="overlay">
    <div class="cv-spinner">
      <span class="spinner"></span>
      <img class="spinner-img" src="/images/loading.gif">
    </div>
  </div>
</template>

<script>
import WebLayout from "./layouts/WebLayout.vue";
import PanelLayout from "./layouts/PanelLayout";
import { initProvincesState } from "../src/state/provinceState";
import { initDashboardState } from "../src/state/dashboardState";
import { RoleAccess } from "../public/js/Utilities";
import { useQueryClient } from '@tanstack/vue-query'
export default {
  components: {
    WebLayout,
    PanelLayout,
  },
  data() {
    return {
      layout: null,
    };
  },
  watch: {
    $route(to) {
      // set layout by route meta
      if (to.meta.layout !== undefined) {
        this.layout = to.meta.layout;
        document.getElementById("page-top").classList.add("bg-gradient-primary");
      } else {
        this.layout = "PanelLayout"; // this is default layout if route meta is not set
        document.getElementById("page-top").classList.remove("bg-gradient-primary");
      }
    },
  },
  methods: {
    Access(RoleNames) {
      return RoleAccess(RoleNames);
    },
    randombg() {

    }
  },
  mounted() {

    setTimeout(() => {
      if (document.getElementsByClassName("modal-open").length > 0) {
        document.getElementsByClassName("modal-open")[0].remove();
      }

      const bigSize = [
        "url(/images/background/bg-1.jpg)", // شنبه
        "url(/images/background/bg-2.jpg)", // یکشنبه
        "url(/images/background/bg-3.jpg)", // دوشنبه
        "url(/images/background/bg-4.jpg)", // سه‌شنبه
        "url(/images/background/bg-5.jpg)", // چهارشنبه
        "url(/images/background/bg-6.jpg)", // پنج‌شنبه
        "url(/images/background/bg-7.jpg)"  // جمعه
      ];

      const today = new Date().getDay(); // 0=یکشنبه ... 6=شنبه

      // فرمول جدید برای تبدیل به روز ایرانی:
      // اگر شنبه (6) است → 0
      // بقیه روزها یکی اضافه می‌شن
      const iranDayIndex = today === 6 ? 0 : today + 1;

      const contentWrapper = document.getElementById("content-wrapper");
      const bgBlur = document.getElementById("bgBlur");

      if (contentWrapper) {
        contentWrapper.style.backgroundImage = bigSize[iranDayIndex];
      }

      if (bgBlur) {
        bgBlur.style.backgroundImage = bigSize[iranDayIndex];

      }
    }, 500);


  },
  created() {
    if (localStorage.getItem("token") != null && this.Access('SurvayManager,SysAdmin,SurvayResultManager,UserManager,CrmManager')) {
      const queryClient = useQueryClient();
      initProvincesState(queryClient);

      if (this.Access('SysAdmin')) {
        initDashboardState(queryClient);
      }
    }
  },
};
</script>

<style></style>